export default {
  namespaced: true,

  state: () => ({
    deliveryTerms: {},
  }),

  getters: {
    deliveryTerms: (state) => state.deliveryTerms,
    receivingMethods: (state) => {
      const terms = state.deliveryTerms?.receivingMethods ?? [];
      return terms.map((term) => {
        if (term === 'express_delivery') {
          // От ProductGate приходит фильтр с названием exp_delivery, поэтому меняем название
          return 'exp_delivery';
        }

        return term;
      });
    },
  },

  mutations: {
    setDeliveryTerms: (state, value) => {
      state.deliveryTerms = { ...value };
    },
  },

  actions: {
    async fetchDeliveryTerms({ commit }) {
      const deliveryTerms = await this.$api.getDeliveryTerms();
      commit('setDeliveryTerms', deliveryTerms);
    },
  },
};
